import { AssignmentsAssignTo } from '../../../types/AssignmentsAssignTo';

export const getMembershipFieldIdFromAssignTo = (assignTo?: Partial<AssignmentsAssignTo>) => {
  return assignTo?.fieldMapping?.toField?.fieldIds?.[0];
};
